export default __webpack_public_path__ + "static/media/Ltst.b3ce4ec4.jpg";